import React, { useEffect, useState } from "react";
import {
    AppBar,
    Box,
    IconButton,
    Toolbar,
    useMediaQuery,
} from "@mui/material";

import SegmentIcon from '@mui/icons-material/Segment';
import MobileMenuDrawer from "./MobileMenuDrawer";
import { HEADER_HEIGHT } from "../utils/anchors";

// Se você tiver um logo em src/assets/lsc-logo.png, pode usar:
import logo from "../assets/lsc-logo.svg";

export default function Header() {
    const isMobile = useMediaQuery("(max-width:900px)");
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 14);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    height: HEADER_HEIGHT,
                    justifyContent: "center",
                    bgcolor: scrolled ? "rgba(0,0,0,0.70)" : "rgba(0,0,0,0.12)",
                    backdropFilter: scrolled ? "blur(12px)" : "blur(6px)",
                    borderBottom: scrolled
                        ? "1px solid rgba(255,255,255,0.08)"
                        : "1px solid rgba(255,255,255,0.04)",
                    transition: "all .25s ease",
                }}
            >
                <Toolbar
                    sx={{
                        minHeight: HEADER_HEIGHT,
                        px: { xs: 3, md: 20 },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    {/* LEFT: LOGO (igual GTA style) */}
                    <Box
                        component="a"
                        href="#inicio"
                        onClick={(e) => {
                            e.preventDefault();
                            const el = document.getElementById("inicio");
                            if (el) window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                            textDecoration: "none",
                            color: "inherit",
                            userSelect: "none",
                        }}
                    >
                        <Box component="img" src={logo} alt="Lusco Produtora" sx={{ height: 28, width: "auto" }} />


                    </Box>

                    <IconButton
                        onClick={() => setOpen(true)}
                        aria-label="Abrir menu"
                        sx={{
                            width: 44,
                            height: 44,
                            borderRadius: 2,
                            color: "var(--branco)",
                            transition: "all .2s ease",
                            "&:hover": {
                                bgcolor: "rgba(255,255,255,0.07)",
                                borderColor: "rgba(172,201,14,0.30)",
                                color: "var(--verdeClaro)",
                            },
                        }}
                    >
                        <SegmentIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <MobileMenuDrawer open={open} onClose={() => setOpen(false)} isMobile={isMobile} />
        </>
    );
}